/**
 * Calculates the active page number based on ITEMS_PER_PAGE, startIndex, and endIndex.
 * @param ITEMS_PER_PAGE Number of items per page.
 * @param startIndex 0-based index of the first item in the current range.
 * @param endIndex 0-based index of the last item in the current range.
 * @returns The active page number (1-based).
 * @throws Error if inputs are invalid.
 */
export function calculateActivePage({
	endIndex,
	itemsPerPage,
	startIndex,
}: {
	endIndex: number
	itemsPerPage: number;
	startIndex: number;
}): number {
	// Validate inputs
	if (!Number.isInteger(itemsPerPage) || itemsPerPage <= 0) {
		throw new Error('itemsPerPage must be a positive integer');
	}
	if (!Number.isInteger(startIndex) || startIndex < 0) {
		throw new Error('startIndex must be a non-negative integer');
	}
	if (!Number.isInteger(endIndex) || endIndex < startIndex) {
		throw new Error('endIndex must be a non-negative integer and greater than or equal to startIndex');
	}
	if (endIndex - startIndex + 1 > itemsPerPage) {
		throw new Error('The range between startIndex and endIndex exceeds itemsPerPage');
	}

	// Calculate active page (1-based)
	return Math.ceil((startIndex + 1) / itemsPerPage);
}
